import React from "react";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ImageIcon from "@mui/icons-material/Image";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { getInitials } from "../../utilities/helpers";
import { formatTimestampWithDate } from "../../../../../helpers/helpers";

function EmployeeProfileNoteEntry(props) {
  return (
    <div className="flex space-x-4">
      {/* Avatar */}
      <div className="flex-shrink-0">
        <div className="w-10 h-10 rounded-full bg-violet-100 text-violet-700 text-sm font-medium flex items-center justify-center">
          {getInitials(props.entry.author_stm.full_name)}
        </div>
      </div>

      {/* Note Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            {/* Author and Date */}
            <div className="flex items-center space-x-2 mb-2">
              <span className="text-sm font-medium text-gray-900">
                {props.entry.author_stm.full_name}
              </span>
              <span className="text-sm text-gray-500">
                {formatTimestampWithDate(props.entry.created_at)}
              </span>
            </div>

            {/* Note Text */}
            <div className="text-gray-700 leading-relaxed">
              {props.entry.value_text}
            </div>

            {/* Attachment */}
            {props.entry?.file_uploads?.length > 0 && (
              <div
                className="inline-flex items-center space-x-2 text-violet-600 hover:text-violet-700 text-sm cursor-pointer bg-violet-50 hover:bg-violet-100 px-3 py-2 rounded-lg transition-colors mt-3"
                onClick={() => props.get_file_upload(props.entry?.file_uploads?.[0])}
              >
                <ImageIcon style={{ fontSize: "16px" }} />
                <span className="font-medium">View Image</span>
              </div>
            )}
          </div>

          {/* Delete Button */}
          <div className="flex-shrink-0 ml-4">
            <Tooltip title="Delete note">
              <IconButton
                size="small"
                onClick={() => props.delete_logbook_employee_entry(props.stm_id, props.entry.uuid)}
                className="text-gray-400 hover:text-red-600 hover:bg-red-50"
              >
                <DeleteOutlinedIcon style={{ fontSize: "18px" }} />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeeProfileNoteEntry;
